import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { ErrorExistingPatient } from 'src/app/utils/interfaces/new/error-existing-patient.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';

export const FORCE_CREATE_PATIENT = 'forceCreatePatient';

interface TablePatient {
  id: string;
  name: string;
  firstname: string;
  birthZip?: string;
  mail?: string;
  tel?: string;
}

@Component({
  selector: 'app-create-patient-exists',
  templateUrl: './create-patient-exists.fragment.html',
  styleUrls: [
    './create-patient-exists.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class CreatePatientExistsFragment implements OnInit {

  public patients: Array<ErrorExistingPatient>;

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  public patientsColumnTable = [
    { title: 'Nom', data: 'name' },
    { title: 'Prénom', data: 'firstname' },
    { title: 'CP naissance', data: 'birthZip' },
    { title: 'Mail', data: 'mail' },
    { title: 'Tel.', data: 'tel' },
  ];
  public patientList: Paginated<TablePatient>;
  public selectedPatient: TablePatient;

  constructor(
    private _strUtilsSrv: StringUtilsService
  ) { }

  ngOnInit(): void {
    this.patientList = {
      objects: this.patients.map<TablePatient>(p => {
        return {
          id: p.id,
          firstname: this._strUtilsSrv.uppercaseFirstCharString(p.prenom),
          name: p.nom.toLocaleUpperCase(),
          birthZip: p.cpNaissance ? p.cpNaissance : '',
          mail: p.mail ? p.mail : '',
          tel: p.telephone ? p.telephone : ''
        } as TablePatient;
      }),
      page: 0,
      perpage: 0,
      total: 0
    };
  }

  public closeModal(object?: undefined | ErrorExistingPatient | string): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public selectLine(patient: TablePatient) {
    if (this.selectedPatient && patient.id === this.selectedPatient.id) {
      this.selectedPatient = undefined;
    } else {
      this.selectedPatient = patient;
    }
    for (const line of this.patientList.objects) {
      if (this.selectedPatient && this.selectedPatient.id === line.id) {
        Object.defineProperty(line, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(line, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(line, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(line, 'textColor', { configurable: true, value: 'var(--black)' });
      }
    }
  }

  public selectPatient() {
    this.closeModal(this.patients[0]);
  }

  public createPatient() {
    this.closeModal(FORCE_CREATE_PATIENT);
  }

}
